import React from 'react';
import { OrderTracker as UIOrderTracker } from '../../../ui/orderTracker';

export default function OrderTracker() {
    return <UIOrderTracker />;
}
